import { KeyValue } from '@angular/common';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { debounceTime, delay, switchMap, tap } from 'rxjs/operators';

interface SearchResult {
  eventListData: any[];
  total: number;
}

interface State {
  page: number;
  pageSize: number;
  searchTerm: string;
}

interface LoatEvent {
  systemInfo: { systemStatus: '' };
  params: [{ contentType: ''; param: ''; valueData: '' }];
}

@Injectable({
  providedIn: 'root',
})
export class TableDataHandlerService {
  private _search$ = new Subject<void>();
  private _events$ = new BehaviorSubject<any[]>([]);
  private _total$ = new BehaviorSubject<number>(0);
  private _tableHeaderConfig$ = new BehaviorSubject<any[]>([]);
  private eventList = new Array<any>();
  private backupeventList = new Array<any>();
  private selectedEvent;
  private cellColors = [{ color: '', event_table_state: '' }];
  private processingEventId = undefined;

  private _state: State = {
    page: 1,
    pageSize: 10,
    searchTerm: '',
  };

  constructor(private translate: TranslateService) {
    this._search$
      .pipe(
        debounceTime(200),
        switchMap(() => this._search())
      )
      .subscribe((result) => {
        this._events$.next(result.eventListData);
        this._total$.next(result.total);
      });
  }

  public startService(eventData) {
    const safeEventData = Array.isArray(eventData) ? eventData : [];
    this.backupeventList = this.cloneEventList(safeEventData);
    this.eventList = this.cloneEventList(this.backupeventList);
    this._search$.next();
  }

  get events$() {
    return this._events$.asObservable();
  }

  get total$() {
    return this._total$.asObservable();
  }

  get page() {
    return this._state.page;
  }

  get pageSize() {
    return this._state.pageSize;
  }

  get searchTerm() {
    return this._state.searchTerm;
  }

  get tableConfigs$() {
    return this._tableHeaderConfig$.asObservable();
  }

  set page(page: number) {
    this._set({ page });
  }
  set pageSize(pageSize: number) {
    this._set({ pageSize });
  }
  set searchTerm(searchTerm: string) {
    this._set({ searchTerm });
  }

  private _set(patch: Partial<State>) {
    Object.assign(this._state, patch);
    this._search$.next();
  }

  private _search(): Observable<SearchResult> {
    const { pageSize, searchTerm } = this._state;
    let eventListData: Array<any> = [];

    for (let i = 0; i < this.eventList.length; i++) {
      for (let j = 0; j < this.eventList[i].params.length; j++) {
        if (
          (this.eventList[i].params[j].param === 'event_id' ||
            this.eventList[i].params[j].param === 'creation_timestamp' ||
            this.eventList[i].params[j].param === 'truck_id') &&
          this.eventList[i].params[j].valueData.includes(searchTerm)
        ) {
          eventListData.push(this.eventList[i]);
          break;
        }
      }
    }

    const total = eventListData.length;
    const maxPage = total > 0 ? Math.ceil(total / pageSize) : 1;
    const safePage = Math.min(Math.max(this._state.page, 1), maxPage);

    this._state.page = safePage;

    eventListData = eventListData.slice(
      (safePage - 1) * pageSize,
      (safePage - 1) * pageSize + pageSize
    );

    return of({ eventListData, total });
  }

  public onCompare(
    _left: KeyValue<any, any>,
    _right: KeyValue<any, any>
  ): number {
    return -1;
  }

  public filterEvents(param, term) {

    console.log('[filterEvents] buscando:', { param, term });

    if (this.backupeventList.length > 0) {
      console.log(
        '[filterEvents] params disponibles primer evento:',
        this.backupeventList[0].params.map((p) => ({
          param: p.param,
          valueData: p.valueData,
        }))
      );
    }

    let foundEventList: Array<any> = [];

    for (let i = 0; i < this.backupeventList.length; i++) {
      for (let j = 0; j < this.backupeventList[i].params.length; j++) {
        if (
          this.backupeventList[i].params[j].param === param &&
          this.backupeventList[i].params[j].valueData == term
        ) {
          foundEventList.push(this.backupeventList[i]);
          break;
        }
      }
    }

    console.log('[filterEvents] encontrados:', foundEventList.length);
    
    const total = foundEventList.length;

    this.eventList = this.cloneEventList(foundEventList);
    this._state.page = 1;
    this._search$.next();

    return of({ foundEventList, total });
  }

  public clearFilters() {
    this.eventList = this.cloneEventList(this.backupeventList);
    this._state.page = 1;
    this._search$.next();
  }

  private cloneEventList(eventData: any[]): any[] {
    return JSON.parse(JSON.stringify(eventData || []));
  }

  colors(wdtkEvent: LoatEvent) {
    if (this.isSelected(wdtkEvent)) {
      let cellColorConfig = this.cellColors.find(
        (element) => element.event_table_state == 'selected'
      );
      return cellColorConfig.color;
    } else {
      let cellColorConfig = this.cellColors.find(
        (element) =>
          element.event_table_state == wdtkEvent.systemInfo.systemStatus
      );
      return cellColorConfig.color;
    }
  }

  selectedBorder(wdtkEvent) {
    if (this.isSelected(wdtkEvent)) {
      return '5px outset #FFFFFF';
    } else {
      return '0px';
    }
  }

  setSelectedEvent(wdtkEvent) {
    //console.log(wdtkEvent);
    //if (
    //  wdtkEvent.systemInfo.systemStatus !== 'locked' ||
    //  wdtkEvent.systemInfo.systemStatus !== 'availableGoodLocked' ||
    //  wdtkEvent.systemInfo.systemStatus !== 'measurementConflcitLocked' ||
    //  wdtkEvent.systemInfo.systemStatus !== 'systemErrorCalcLocked'
    //) {
    this.selectedEvent = wdtkEvent;
    //}
  }

  isSelected(wdtkEvent) {
    if (this.selectedEvent != undefined) {
      let selectedEventID;

      for (let j = 0; j < this.selectedEvent.params.length; j++) {
        if (this.selectedEvent.params[j].param === 'event_id') {
          selectedEventID = this.selectedEvent.params[j].valueData;
          break;
        }
      }

      for (let j = 0; j < wdtkEvent.params.length; j++) {
        if (
          wdtkEvent.params[j].param === 'event_id' &&
          selectedEventID == wdtkEvent.params[j].valueData
        ) {
          return true;
        }
      }
    }
    return false;
  }

  setTableRender(tableRenderConfig) {
    //console.log(tableRenderConfig);
    this.cellColors = tableRenderConfig.colorSchema;
    this._tableHeaderConfig$.next(tableRenderConfig.clienConfig);
    if (tableRenderConfig.language == 0) {
      this.translate.use('en');
    }

    if (tableRenderConfig.language == 1) {
      this.translate.use('es');
    }
  }

  setStatusIcon(last_state) {
    switch (Number(last_state)) {
      case 0:
        return '../../../assets/icons/icons8-available-64.png';
      case 1:
      case 11:
        return '../../../assets/icons/icons8-guard-64.png';
      case 2:
      case 3:
      case 5:
      case 6:
      case 7:
        return '../../../assets/icons/icons8-automatic-64.png';
      case 4:
      case 8:
        return '../../../assets/icons/icons8-datanomics-64.png';
      case 9:
        return '../../../assets/icons/icons8-output-64.png';
      case 10:
        return '../../../assets/icons/icons8-system-64.png';
      case 12:
        return '../../../assets/icons/icons8-activity-64.png';
      case 13:
        return '../../../assets/icons/icons8-excellent-64.png';
      case 14:
        return '../../../assets/icons/icons8-correction-64.png';
    }
  }

  setSatusText(last_state) {
    switch (Number(last_state)) {
      case 0:
        return 'status.available-event';
      case 1:
        return 'status.busy-event';
      case 2:
        return 'status.waiting-calc-results';
      case 3:
        return 'status.asisted-event-waiting-sync';
      case 4:
        return 'status.assisted-event';
      case 5:
        return 'status.recalculating-event';
      case 6:
        return 'status.waiting-recalc-results';
      case 7:
        return 'status.recalculated-event-waiting-for-sync';
      case 8:
        return 'status.recalculated-event';
      case 9:
        return 'status.sent-event-waiting-sync';
      case 10:
        return 'status.event-send';
      case 11:
        return 'status.unavaliable-event';
      case 12:
        return 'status.accepted-waiting-sync-event';
      case 13:
        return 'status.accepted-event';
      case 14:
        return 'status.undo-calc-waiting-sync';
    }
  }

  setTableHeaderId(tableConfig) {
    if (tableConfig.contentType === 'array_string') {
      let firstElement = tableConfig.headerContent[0].value;
      firstElement = firstElement.toLowerCase().replace(/ /g, '_');
      return 'table_header_' + firstElement;
    }

    if (tableConfig.contentType === 'image') {
      switch (tableConfig.headerContent) {
        case '../../../assets/icons/icons8_Camera_Identification_24px.png':
          return 'table_header_plate_image';
        case '../../../assets/icons/icons8_Truck_24px.png':
          return 'table_header_truck_image';
      }
    }
  }
}
